import { HttpClient } from 'api/http-client';

class ProjectAPIClient extends HttpClient {
  public async getProjectList(): Promise<any[]> {
    return this.get<any[]>('/projects?lite=true');
  }
  public async init(): Promise<any> {
    return this.get<any>('/home/init');
  }
}

export const ProjectAPI = new ProjectAPIClient();
